<template>
  <div class="modal open_modal" data-modal="modal">
    <div class="modal_overlay" data-modal-close="modal"></div>
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="d_flex_btwn">
          <h3>{{ title }}</h3>
          <span>
              <span data-modal-close="modal" class="close_icon close_icon_md" @click.prevent="closeModal"></span>
          </span>
        </div>
      </div>
      <div class="modal_inner">
        <div class="modal_content height_100p" :class="size">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: ['title', 'closeModal', 'size']

}
</script>